import SvgIcon from "./IconImage.svg?react";
const IconImage = SvgIcon;
export default IconImage;
